import React, { useState } from "react";
import "./PromocodeTable.css";
import { FiEdit, FiTrash } from "react-icons/fi";
import EditPromocodeModal from "../EditPromocodeModal/EditPromocodeModal";
import DeletePromocodeModal from "./DeletePromocodeModal/DeletePromocodeModal";

const PromocodeTable = ({ data = [], page, limit, refreshData }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedPromocode, setSelectedPromocode] = useState(null);

  const handleEdit = (promocode) => {
    setSelectedPromocode(promocode);
    setShowModal(true);
  };

  const handleDelete = (promocode) => {
    setSelectedPromocode(promocode);
    setShowDeleteModal(true);
  };

  return (
    <div className="role-table-wrapper">
      <table className="role-table">
        <thead>
          <tr>
            <th className="td-sr">Sr. No</th>
            <th>Title</th>
            <th>Promocode</th>
            <th>Percentage</th>
            <th>Expiry Date</th>
            <th>Usage Limit</th>
            <th>Total Used</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item._id}>
                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                <td>{item.title || "-"}</td>
                <td>{item.code || "-"}</td>
                <td>{item.discountType === "percentage" ? `${item.discountValue}%` : item.discountValue || "-"}</td>
                <td>
                  {item.validTill
                    ? new Date(item.validTill).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "-"}
                </td>
                <td>{item.usageLimit || "-"}</td>
                <td>{item.usedCount || 0}</td>
                <td className="action-col">
                  <button
                    className="chat-btn edit-btn"
                    onClick={() => handleEdit(item)}
                  >
                    <FiEdit size={16} />
                  </button>

                  <button
                    className="chat-btn delete-btn"
                    onClick={() => handleDelete(item)}
                  >
                    <FiTrash size={16} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                No promocodes available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {selectedPromocode && (
        <>
          <EditPromocodeModal
            isOpen={showModal}
            promocode={selectedPromocode}
            onClose={() => setShowModal(false)}
            refreshData={refreshData}
          />

          <DeletePromocodeModal
            isOpen={showDeleteModal}
            promocode={selectedPromocode}
            onClose={() => setShowDeleteModal(false)}
            refreshData={refreshData}
          />
        </>
      )}
    </div>
  );
};

export default PromocodeTable;
